import { QueryClient } from "@tanstack/react-query";

/**
 * Shared QueryClient instance. Lives outside `main.tsx` so non-component
 * modules (e.g. the idle-logout flow, GRA-80) can clear the cache on sign-out
 * without importing the app entry point.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      gcTime: 15 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});
